<template>
  <div class="password">
    <div class="headertop flex">
      <span style="flex: 8; font-size: 1.6rem; color: #2bae85; font-weight: 700"
        >云上初阳统一登录认证平台</span
      >
      <span style="float: right; flex: 2">
        <router-link to="/" class="link" style="margin-right: 0.3rem"
          >云上初阳PCB网站</router-link
        >|
        <router-link to="/" class="link" style="margin-left: 0.3rem"
          >登录</router-link
        >
      </span>
    </div>
    <div class="center flex">
      <div class="Modify">
        <p>用户注册<img src="../../assets/imges/笔 (2)(1).png" alt="" /></p>
        <hr />
        <ul>
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >注册:</span
            >
            <el-select
              v-model="registered.select"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="个人" value="1"></el-option>
              <el-option label="企业" value="2"></el-option>
            </el-select>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >您的手机号:</span
            >
            <el-input
              v-model="registered.Phone"
              placeholder="请输入内容"
            ></el-input>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >您的验证码:</span
            >
            <el-input
              v-model="registered.coded"
              placeholder="请输入内容"
            ></el-input>
            <el-button
            v-if="time==0"
              style="width: 5rem; padding: 5px 0 5px 0"
              size="mini"
              @click="Verification"
              >发送验证码</el-button
            >
            <span v-else style="width: 5rem; padding: 5px 0 5px 0;font-size:0.6rem;color:#f00">
              {{time}}s重新发送
            </span>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >您的邀请码:</span
            >
            <el-input
              v-model="registered.invitation"
              placeholder="请输入内容"
            ></el-input>
          </li>

          <li>
            <div class="radio">
              <el-checkbox v-model="agreement" label="1"
                >我已看过并同意<a href="#">《服务协议》</a></el-checkbox
              >
            </div>
          </li>
          <li style="margin-left: 20%">
            <el-button type="warning" @click="complete"
              ><i style="margin-right: 1rem">注</i><i>册</i></el-button
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <p>云上初阳</p>
      <div class="flex">
        <ul style="flex: 1">
          <li>业务经理:彭易权</li>
          <li>联系电话:0755-23080620</li>
          <li>手机号码:18129846935</li>
          <li>联系 Q Q:574039568</li>
        </ul>
        <ul style="flex: 1">
          <li>业务专员:陈泰先</li>
          <li>联系电话: <span>0755-23080620</span></li>
          <li>手机号码:13129338939</li>
          <li>联系 Q Q: <span>1025203743</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {getUser} from "../../api/http/user"
import { getPay } from "../../api/http/pay";
export default {
  data() {
    return {
      pwd: "", //确认密码
      agreement: true, //是否同意服务协议
      vftTime:null,//定时器
 time:0,//
      // 注册信息
      registered: {
        Phone: "",
        coded: "",
        select: "1",
        invitation: "",
      },
    };
  },
  methods: {
    complete() {
      //  注册前验证
      let params={
        type:this.registered.select,
        invitationCode:this.registered.invitation,
        phone:this.registered.Phone,
        verifyCode:this.registered.coded
      }
      getUser.getRegister(params).then(res=>{
        clearInterval(this.vftTime);

        if(res.data.code==200){
          window.sessionStorage.setItem("token", res.data.data.Token);
          window.sessionStorage.setItem("Avatar", res.data.data.Avatar);
          window.sessionStorage.setItem("Name", res.data.data.Name);
           this.$router.push({path:"/login"})
        }else{
          this.$message({
            message:res.data.msg,
            type:"error"
          })
        }
      })
    },
    //   发送验证码
    Verification() {
      if(this.registered.Phone==''){
       return this.$message({
          message:"手机号不能为空",
          type:"error"
        })
      }else if(this.registered.Phone.length!=11){
         return this.$message({
          message:"请输入正确的手机号！",
          type:"error"
        })
      }
      let params = {
        phone: this.registered.Phone,
        type: 4,
      };
            getPay.getSendsms(params).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.time = 60;
            this.vftTime = setInterval(() => {
              --this.time;
              if (this.time == 0) {
                clearInterval(this.vftTime);
              }
              console.log(this.time);
            }, 1000);
            this.$message({
              message: "验证码发送成功!",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.password {
  // 底部样式
  .bottom {
    margin: auto;
    width: 100%;
    background-color: #fafafa;
    text-align: center;
    padding-bottom: 1rem;
    position: fixed;
    bottom: 0;
    p {
      font-size: 1.5rem;
      color: #2bae85;
      font-weight: 600;
      margin-top: 1rem;
    }
    .flex {
      width: 350px;
      margin: auto;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      ul {
        width: 50%;
        li:hover {
          color: #2bae85;
        }
        li {
          text-align: left;
          font-size: 0.8rem;
        }
      }
    }
  }
  // 头部样式
  .headertop {
    width: 60%;
    margin: auto;
    height: 100px;
    align-items: center;
    justify-content: center;
    background-color: #fafafa;
    span {
      .link {
        color: #6f6f6f;
      }
      .link:hover {
        color: #2bae85;
      }
    }
  }
  // 中间样式
  .center {
    height: 35rem;
    background-color: #2bae85;
    width: 100%;
    justify-content: center;
    align-items: center;
    ul {
      margin: auto;
      text-align: left;
      margin-left: 10rem;
      li {
        height: 3rem;
        .radio {
          position: absolute;
          left: 50%;
          transform: translateX(-60%);
        }

        span {
          text-align-last: justify;
          display: inline-block;
          width: 90px;
          font-size: 0.9rem;
        }
        .el-button {
          width: 150px;

          i {
            font-style: unset;
            font-size: 1rem;
            text-align: center;
          }
        }
        .el-input {
          width: 200px;
        }
        img {
          padding-top: 0.2rem;
          width: 1rem;
        }
      }
    }
    .Modify {
      border: 0.1rem solid #dddddd;
      height: 25rem;
      width: 40%;
      background-color: #f8f8f8;
      border-radius: 0.3rem;
      ul {
        display: flex;
        flex-direction: column;
        justify-content: center;
        li {
          margin-top: 1rem;
        }
      }
      hr {
        padding-top: 0.2rem;
        background-color: #dedede;
      }
      p {
        font-size: 1.5rem;
        color: #6f6f6f;
        padding-left: 0.8rem;
        padding-bottom: 0.5rem;
        img {
          width: 1rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ChildComponents/registered.vue